import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../assets/css/agent/ticket-emails.scss";
import FeaturesTab from "../../components/FeaturesTab";
import { AiOutlineReload, AiOutlineDown } from "react-icons/ai";
import RightBar from "../../components/RightBar";
import axiosInstance from "../../environment/axiosInstance";
import { useParams } from "react-router-dom";
import { HiOutlineReply } from "react-icons/hi";
import "../../assets/css/pagination.scss";
import moment from "moment";

function TicketEmails() {
    const { userId } = useParams();
    const history = useHistory();
    const [opened_tab, setOpenedTab] = useState(null);
    const [emails, setEmails] = useState([]);
    const [page, setPage] = useState(1);
    const [replyInputIsOpen, setReplyInputIsOpen] = useState(false);
    const [reply, setReply] = useState("");

    const useQuery = () => {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let searchParams = useQuery();

    useEffect(() => {
        fetchEmails(searchParams.get("ticket_id"));
    }, []);

    useEffect(() => {
        var user_tabs = JSON.parse(localStorage.getItem("user_tabs"));
        setOpenedTab(user_tabs.filter(tab => tab.id == userId)[0]);
    }, [userId]);

    const fetchEmails = () => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/ticket/getemails/" + searchParams.get("ticket_id"))
            .then(response => {
                if (response.data) {
                    response.data.Data?.map(email => {
                        email.isOpen = false;
                    });
                    setEmails(response.data.Data);
                }
            });
    }

    const replyBtnClicked = () => {
        axiosInstance
            .post(process.env.REACT_APP_API_URL + "/support/business_owner/email/send-email", {
                subject: "Ticket#" + emails[0]?.ticket_id?.ticket_id,
                textContent: reply,
                ticket_id: emails[0]?.ticket_id?._id,
                customer_id: userId
            })
            .then(response => {
                if (response.data) {
                    fetchEmails();
                    setReply("");
                }
            });
    }

    return (
        <div>
            {/* <Header />
            <UsersTabs /> */}
            <div className="ticket-emails row m-0">
                {/* <div
                    className="p-0 left-col"
                    style={{
                        borderRight: "1px solid #D9D9D9"
                    }}
                >
                    <LeftBar />
                </div> */}
                <div className="p-0 center-col">
                    <FeaturesTab />
                    <div className="emails-content">
                        <div className="top-bar row m-0">
                            <div className="col-6 p-0 d-flex align-items-center left">
                                {/* <div className="d-flex align-items-center cursor-pointer">
                                    <input type="checkbox" />
                                    <AiOutlineDown
                                        size={16}
                                        className="ms-1"
                                        onClick={() => setCheckboxDropdownOpen(!checkboxDropdownOpen)}
                                    />
                                </div>
                                {
                                    checkboxDropdownOpen ?
                                        <div className="dropdown-menu">
                                            <p className="m-0 menu-item">All</p>
                                            <p className="m-0 menu-item">Read</p>
                                            <p className="m-0 menu-item">Unread</p>
                                        </div>
                                        :
                                        <></>
                                } */}
                                <p className="m-0 title">Ticket # <span>{emails[0]?.ticket_id?.ticket_id}</span></p>
                            </div>
                        </div>
                        <div className="emails-section">
                            {
                                emails?.map(email => {
                                    return (
                                        <div className="email-row row m-0 justify-content-between">
                                            <div className="d-flex left">
                                                <div className={
                                                    "profile-icon" + (
                                                        email.from_id == JSON.parse(localStorage.getItem("user_data"))?.userData?.id ?
                                                            ""
                                                            :
                                                            " profile-icon-customer"
                                                    )
                                                }>
                                                    <p className="m-0">
                                                        {
                                                            email.from_id == JSON.parse(localStorage.getItem("user_data"))?.userData?.id ?
                                                                "Y"
                                                                :
                                                                email.customer?.customer_name[0]
                                                        }</p>
                                                </div>
                                                <div>
                                                    <p className="m-0 user-name">
                                                        {
                                                            email.from_id == JSON.parse(localStorage.getItem("user_data"))?.userData?.id ?
                                                                "You"
                                                                :
                                                                email.customer?.customer_name
                                                        }
                                                    </p>
                                                    <p className="m-0 email-text">{email.plain_body}</p>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p className="m-0 date-time">{moment(email.createdAt).format('DD-MM-YYYY')}</p>
                                                <p className="m-0 date-time">{moment(email.createdAt).format('hh:mm a')}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                replyInputIsOpen ?
                                    <></>
                                    :
                                    <div className="buttons-row">
                                        <div
                                            className="button"
                                            onClick={() => setReplyInputIsOpen(true)}
                                        >
                                            <HiOutlineReply
                                                size={20}
                                                color="#7455F6"
                                            />
                                            <p className="m-0">Reply</p>
                                        </div>
                                    </div>
                            }
                            {
                                replyInputIsOpen ?
                                    <div
                                        className="email-row row mx-0"
                                        style={{
                                            width: "100%",
                                            marginTop: "30px",
                                            border: "none"
                                        }}>
                                        <div
                                            className="d-flex left"
                                            style={{
                                                width: "100%"
                                            }}>
                                            <div className="profile-icon">
                                                <p className="m-0">{JSON.parse(localStorage.getItem("user_data"))?.userData?.name[0]}</p>
                                            </div>
                                            <div className="reply-email w-75">
                                                <div className="top-row d-flex align-items-center">
                                                    <HiOutlineReply
                                                        size={16}
                                                        color="#7455F6"
                                                    />
                                                    <p className="m-0 user-name">{emails[0]?.customer.customer_name}</p>
                                                    <p className="m-0 email">({emails[0]?.customer.customer_email})</p>
                                                </div>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Write email here..."
                                                    rows={5}
                                                    value={reply}
                                                    onChange={(e) => setReply(e.target.value)}
                                                ></textarea>
                                                <input
                                                    type="button"
                                                    className="send-btn"
                                                    value="Send"
                                                    onClick={replyBtnClicked}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <></>
                            }
                        </div>
                    </div>
                </div>
                <div
                    className="p-0 right-col"
                    style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}
                >
                    <RightBar />
                </div>
            </div>
        </div>
    )
}

export default TicketEmails;